import { DataSourceForm } from '@/components/admin/data-sources/DataSourceForm';
import { PageHeader } from '@/components/layout/PageHeader';
import { PageShell } from '@/components/layout/PageShell';
import { ApiError, api } from '@/lib/api';
import type { CreateDataSourceRequest } from '@innermate/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { useState } from 'react';

export function AdminDataSourceNew() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [serverError, setServerError] = useState<string | null>(null);

  const mutation = useMutation({
    mutationFn: (body: CreateDataSourceRequest) => api.dataSourceCreate(body),
    onSuccess: (created) => {
      qc.invalidateQueries({ queryKey: ['admin', 'data-sources'] });
      navigate({
        to: '/admin/data-sources/$id',
        params: { id: created.id },
      });
    },
    onError: (err: unknown) => {
      setServerError(err instanceof ApiError ? err.message : '데이터소스 등록에 실패했습니다.');
    },
  });

  return (
    <PageShell
      header={
        <>
          <button
            type="button"
            onClick={() => navigate({ to: '/admin/data-sources' })}
            className="mb-4 inline-flex items-center gap-1 text-xs text-foreground-muted hover:text-foreground"
          >
            <ArrowLeft className="size-3.5" />
            데이터 소스 목록
          </button>
          <PageHeader
            title="데이터소스 추가"
            description="등록 후 구조 sync 가 백그라운드에서 실행되고, 이어서 컬럼 통계 sync 가 진행됩니다."
          />
        </>
      }
    >
      <div className="max-w-2xl">
        {serverError ? (
          <div
            role="alert"
            className="mb-4 rounded-md border border-destructive/30 bg-destructive/5 px-3 py-2 text-sm text-destructive"
          >
            {serverError}
          </div>
        ) : null}

        <DataSourceForm
          mode="create"
          submitLabel="데이터소스 만들기"
          submitting={mutation.isPending}
          onSubmit={(body) => {
            setServerError(null);
            mutation.mutate(body as CreateDataSourceRequest);
          }}
          onCancel={() => navigate({ to: '/admin/data-sources' })}
        />
      </div>
    </PageShell>
  );
}
